/* eslint-disable vue/require-v-for-key */
<template>
  <v-container id="moduleedit">
    <v-card> 
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <v-overlay :value="loading">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
          />
        </v-overlay>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-tabs v-model="tab">
             <v-tab>{{ $t('catalogedit.panel.basic') }}</v-tab>
             <v-tab 
              v-for="(locale, index) in model.availableLocales"
              :key="index"
              >
{{ locale }}
</v-tab>
            <v-tab-item key="basic">
              <v-row>
                <v-col>
                <v-text-field
                  v-model="model.uid"
                  :label="$t('catalogedit.label.module-id')"
                  hint="Should match the ID built in the app"
                  :rules="[rules.required]"
                  required
                />
                </v-col>
              </v-row>
              <v-expansion-panels v-model="panels" focussed>
                <v-expansion-panel key="listing">
                  <v-expansion-panel-header>
                    {{ $t('catalogedit.panel.listing') }}
</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col>
                    <v-switch
                      v-model="model.public"
                      :label="$t('catalogedit.label.public')"
                      hint="Will become visible to all accounts that have access to entire library"
                    />
                  </v-col>
                  <v-col>
                    <v-menu v-model="menu" :close-on-content-click="false">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="model.releaseDate"
                            :label="$t('catalogedit.label.release-date')"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          />
                        </template>
                        <v-date-picker v-model="model.releaseDate" @change="menu = false" />
                      </v-menu>
                  </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                      v-model="model.infoLink"
                      :label="$t('catalogedit.info-link')"
                      hint="Link to more information about the module"
                    />
                    </v-col>
                    <v-col>
                      <v-combobox
                      v-model="model.availableLocales"
                      :label="$t('catalogedit.label.supported-language')"
                      required
                      :rules="[rules.localeRules]"
                      multiple
                      chips
                      :items="languages"
                    />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                      v-model.number="model.duration"
                      :label="$t('catalogedit.label.duration')"
                      type="number"
                    />
                    </v-col>
                    <v-col>
                      <v-select
                        v-model="model.type"
                        :items="contentTypes"
                        :label="$t('catalogedit.type')"
                        :value="'module'"
                      />
                    </v-col>
                  </v-row>  
                  <v-row>
                    <v-col>
                      <v-checkbox
                        v-model="model.learnerReports"
                        :label="$t('catalogedit.label.learner-reports')"
                      />
                    </v-col>
                    <v-col>
                      <v-select
                        v-model="model.aiUsage"
                        :label="$t('catalogedit.label.aiusage')"
                        :items="aiUsage"
                      />
                    </v-col>
                  </v-row>  
                  <v-row>
                    <v-col>
                      <v-checkbox
                          v-model="model.vrRecommended"
                          :label="$t('catalogedit.vrRecommended')"
                        />
                    </v-col>
                    <v-col>
                      <v-text-field
                      v-model="model.flag"
                      label="Feature flag use wisely (else leave blank)"
                      />
                  </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <h3>{{ $t('catalogedit.label.tags') }}</h3>
                    </v-col>
                  </v-row>
                  
                  <div 
                    v-for="(tag, index) in model.tags" 
                    :key="index"
                  >
                    <v-row>
                      <v-text-field
                        v-model="model.tags[index]"
                      />
                    </v-row>
                  </div>
                  
                  <v-row>
                    <v-btn icon small @click="addTag">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-row>
                  <v-row>
                    <v-text-field
                      v-model="newTag"
                      :label="$t('catalogedit.label.new-tag')"
                    />
                  </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel key="structure">
                  <v-expansion-panel-header>
                    {{ $t('catalogedit.panel.structure') }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-select
                      v-model="model.navigationType"
                      :items="['linear', 'free']"
                      :label="$t('catalogedit.label.navigation-type')"
                    />
                    <div>
                      <p>{{ $t('catalogedit.label.topics') }} (total {{ sumCompletion }})</p>
                      <div v-for="(topic, i) in model.topics" :key="i" class="my-2">
                      <v-row>
                        <v-col cols="3">
                          <v-text-field
                            v-model="topic.id"
                            :label="$t('catalogedit.label.id')"
                            outlined
                            dense
                          />
                        </v-col>
                        <v-col cols="3">
                          <v-text-field
                            v-model.number="topic.duration"
                            :label="$t('catalogedit.label.duration')"
                            type="number"
                            outlined
                            dense
                          />
                        </v-col>
                        <v-col cols="3">
                          <v-text-field
                            v-model.number="topic.completion"
                            :label="$t('catalogedit.label.completion')"
                            type="number"
                            outlined
                            dense
                          />
                        </v-col>
                        <v-col cols="3" class="text-right">
                          <v-btn icon small @click="deleteTopic(i)">
                            <v-icon>mdi-minus</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                      </div>
                      <v-btn icon small @click="addNewTopic">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel key="platforms"> 
                  <v-expansion-panel-header>
                    {{ $t('catalogedit.panel.platforms') }}
</v-expansion-panel-header>  
                  <v-expansion-panel-content>
                    <v-text-field
                      v-model="model.bundleID"
                      :label="$t('catalogedit.label.bundle-id')"
                      hint="leave blank for OTS build"
                    />
                    <v-combobox
                      v-model="model.platforms"
                      multiple
                      :items="platforms"
                      :label="$t('catalogedit.label.supported-platforms')"
                      append-icon
                      chips
                      deletable-chips
                      class="tag-input"
                      hint="Leave blank for all platform support"
                    />
                    <v-expansion-panels accordion>
                      <v-expansion-panel key="showLinkOverrides">
                        <v-expansion-panel-header>{{ $t('catalogedit.panel.download-links') }}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div v-for="platform of model.platforms" :key="platform" dense>
                              <v-text-field
                                v-model="launchLinks[platform]"
                                :label="platform"
                                :rules="[rules.urlRules]"
                                dense
                              />
                            </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-tab-item>
            <v-tab-item
              v-for="locale in model.availableLocales"
              :key="locale"
              >
              <v-text-field
                v-model="model.locales[locale].title"
                :label="$t('catalogedit.label.title')"
                required 
              />
              <v-text-field
                v-model="model.locales[locale].promoText"
                :label="$t('catalogedit.label.promo-text')"
              />
              <v-combobox
                v-model="model.locales[locale].keywords"
                multiple
                :label="$t('catalogedit.label.keywords')"
                append-icon
                chips
                deletable-chips
                class="tag-input"
              />

              <div 
                v-for="(topic) in model.topics" 
                :key="topic.id"
              >
                <v-text-field
                  :value="topicName(locale, topic.id)"
                  :label="topic.id"
                  @input="newValue => updateTopicName(newValue, locale, topic.id)"
                />
              </div>

              <div 
                v-for="(fieldValue, fieldName) in model.locales[locale].extras" 
                :key="fieldName"
              >
                <v-text-field
                  :value="fieldValue"
                  :label="fieldName"
                  @input="newValue => updateLocaleField(newValue, locale, fieldName)"
                />
              </div>

              <div>
                <v-btn icon small @click="addNewLocaleAttribute">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
                <v-text-field
                  v-model="newLocaleAttribute"
                  :label="$t('catalogedit.label.new-locale')"
                />
              </div>

              <div>
                <v-col>
                  <h3>{{ $t('catalogedit.label.promo-list') }}</h3>
                </v-col>
              </div>
              
              <div 
                v-for="(line, index) in model.locales[locale].promoList" 
                :key="index"
              >
                <v-text-field
                  v-model="model.locales[locale].promoList[index]"
                />
              </div>
              
              <div>
                <v-btn icon small @click="addPromo(locale)">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </div>
              <div>
                <v-text-field
                  v-model="newPromo"
                  :label="$t('catalogedit.label.new-promo')"
                />
              </div>

              <v-switch
                v-model="model.locales[locale].captioned"
                :label="$t('catalogedit.label.captioned')"
              />
            </v-tab-item>
          </v-tabs>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="loading"
          color="grey"
          @click="importJson"
        >
          {{ $t('global.import') }}
        </v-btn>
        <v-btn
          :disabled="loading"
          color="grey"
          @click="exportJson"
        >
          {{ $t('global.export') }}
        </v-btn>
        <v-btn
          color="blue darken-1"
          @click="cancel"
        >
          {{ $t('global.cancel') }}
        </v-btn>
        <v-btn
          :disabled="!valid"
          color="success"
          @click="validate"
        >
          {{ $t('global.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container> 
</template>

<script>

  import supportedPlatforms from '@/cfg/supported-platforms'
  import api from '@/helpers/api.js'
  import { getSupportedLocales } from '@/util/i18n/supported-locales'
  import { ContentLibrary } from '@/helpers/contentLibrary.js'

  export default {
    name: 'ContentEdit',

    props: {
      moduleid: {
        type: String,
        required: false,
        default: undefined,
      },
    },

  
    data () {
      return {
        contentTypes: Object.values(ContentLibrary.ContentType),
        valid: false,
        loading: false,
        search: '',
        tab: null,
        showLinkOverrides: false,
        platforms: supportedPlatforms.All,
        launchLinks: {},
        menu: false,
        panels: 0,
        localesTemplate: {
          title: '',
          promoText: '',
          keywords: [],
          topicNames: {},
          captioned: false,
        },
        newLocaleAttribute: '',
        newTag: '',
        newPromo: '',
        defaultModuleFields: {
          promoList: [],
          uid: undefined,
          title: '',
          description: '',
          groupid: '',
          availableLocales: ['en'],
          duration: 30,
          keywords: [],
          public: true,
          topics: [],
          navigationType: 'linear',
          vrRecommended: false,
          platforms: [],
          bundleID: '',
          releaseDate: '',
          launchLinks: {},
          locales: {
            en: {
              captioned: false,
              topicNames: {},
              keywords: [],
              promoText: '',
              title: '',
            },
          },
          type: ContentLibrary.ContentType.Module,
          tags: [],
        },
        aiUsage: ['none', 'optional', 'required'],
        model: {},
        rules: {
          required: value => !!value || this.$t('global.required'),
          localeRules: value => !!value || this.$t('catalogedit.requires-at-least-one-language'),
          urlRules: value => !value || (/^(https?|chrome):\/\/[^\s$.?#].[^\s]*$/.test(value)) || this.$t('catalogedit.invalid-url'),
        },
      }
    },

    computed: {
      languages () {
        return getSupportedLocales().map((locale) => locale.code)
      },
      sumCompletion () {
        return this.model.topics?.reduce((a, b) => a + b.completion, 0) ?? 0
      },
      title () {
        return this.model.uid === undefined ? this.$t('catalog.create-content') : this.$t('catalogedit.edit-content')
      },
      topicName: {
        get () {
          return (locale, topicID) => {
            if (this.model.locales?.[locale] === undefined) {
              this.$set(this.model.locales, locale, this.localesTemplate)
            }
            if (this.model.locales?.[locale]?.topicNames?.[topicID] === undefined) {
              return ''
            }
            return this.model.locales?.[locale].topicNames[topicID]
          }
        },
        set () {
          return (locale, topicID, value) => {
            this.$set(this.model.locales?.[locale].topicNames, topicID, value)
          }
        },
      },
    },

    watch: {
      moduleid: async function (newModuleID, oldVal) {
        await this.loadModule(newModuleID)
      },
      // eslint-disable-next-line quote-props
      'model': function (newModel, oldModel) {
        this.launchLinks = newModel.launchLinks ?? undefined
      },
      'model.topics': function (newVal, oldVal) {
        if (this.model.locales === undefined) {
          this.$set(this.model, 'locales', {})
        }
        const newLocales = JSON.parse(JSON.stringify(this.model.locales))
        if (newVal === undefined) {
          newVal = []
        }
        if (newLocales.en.topicNames === undefined) {
          this.$set(newLocales.en, 'topicNames', {})
        }
        
        newVal.forEach((topic) => {
          if (!Object.keys(this.model.locales.en.topicNames).includes(topic.id)) {
            newLocales.en.topicNames[topic.id] = ''
          }
        })

        // go through all locales and remove any topicNames that are not in topics
        Object.keys(newLocales).forEach((locale) => {
          if (newLocales[locale].topicNames !== undefined) {
            Object.keys(newLocales[locale].topicNames).forEach((topicID) => {
              if (!newVal.map((topic) => topic.id).includes(topicID)) {
                delete newLocales[locale].topicNames[topicID]
              }
            })
          }
        })

        this.$set(this.model, 'locales', newLocales)
        this.$set(this.model, 'topics', newVal)
      },
      'model.availableLocales': function (newVal, oldVal) {
        if (this.model.locales === undefined) {
          this.$set(this.model, 'locales', {})
        }

        const newLocales = JSON.parse(JSON.stringify(this.model.locales))
        newVal.forEach((locale) => {
          if (!Object.keys(this.model.locales).includes(locale)) {
            newLocales[locale] = this.localesTemplate
          }
        })
        Object.keys(this.model.locales).forEach((locale) => {
          if (!newVal.includes(locale)) {
            delete newLocales[locale]
          }
        })
        this.$set(this.model, 'locales', newLocales)
        this.$set(this.model, 'availableLocales', newVal)
      },
      // eslint-disable-next-line quote-props
      launchLinks: function (newVal, oldVal) {
        this.model.launchLinks = newVal
      },
    },

    async created () {
      await this.loadModule(this.moduleid)
      // await this.$store.dispatch('content/getContents')
    },

    methods: {
      addTag: function () {
        if (this.newTag) {
          this.model.tags.push(this.newTag)
          this.newTag = '' // Clear the input field after adding the tag
        } else {
          alert('Tag cannot be empty')
        }
      },
      addPromo: function (locale) {
        if (this.newPromo) {
          if (this.model.locales[locale].promoList === undefined) {
            this.model.locales[locale].promoList = []
          }
          this.model.locales[locale].promoList.push(this.newPromo)
          this.newPromo = '' // Clear the input field after adding the tag
        } else {
          alert('Promo Line cannot be empty')
        }
      },
      updateTags: function (newValue, index) {
        this.$set(this.model.tags, index, newValue)
      },
      addNewLocaleAttribute () {
        if (this.newLocaleAttribute) {
          const newLocales = JSON.parse(JSON.stringify(this.model.locales))

          for (const locale in newLocales) {
            // Check if extras exists in the locale, if not, create it
            if (!newLocales[locale].extras) {
              this.$set(newLocales[locale], 'extras', {})
            }

            // Now you can safely add the new attribute to extras
            this.$set(newLocales[locale].extras, this.newLocaleAttribute, '')
          }

          this.$set(this.model, 'locales', newLocales)
          this.newLocaleAttribute = ''
        } else {
          alert(this.$t('catalogedit.empty-attribute'))
        }
      },
      importJson: function () {
        const input = document.createElement('input')
        input.type = 'file'
        input.onchange = e => {
          const file = e.target.files[0]
          const reader = new FileReader()
          reader.readAsText(file, 'UTF-8')
          reader.onload = readerEvent => {
            const content = readerEvent.target.result
            this.model = JSON.parse(content)
          }
        }
        input.click()
      },
      exportJson: function () {
        const json = JSON.stringify(this.model, null, 2)
        // open a new window to download this to the browser
        const blob = new Blob([json], { type: 'application/json' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', this.model.uid + '.json')
        document.body.appendChild(link)
        link.click()
      },
      async loadModule () {
        this.loading = true
        if (this.moduleid) {
          const contentFromDB = await api.getContent(this.moduleid)
          this.model = { ...this.defaultModuleFields, ...contentFromDB }
        } else {
          this.model = { ...this.defaultModuleFields }
        }
        this.loading = false
      },
      addNewTopic () {
        if (this.model.topics === undefined) {
          this.$set(this.model, 'topics', [])
        }
        const topic = {
          id: 'checkpoint' + (this.model.topics.length + 1),
          duration: 0,
          completion: 0,
        }
        this.model.topics.push(topic)
      },
      deleteTopic (index) {
        this.model.topics.splice(index, 1)
      },
      async validate () {
        if (this.moduleid) {
          if (this.model.flag === '') {
            this.model.flag = null
          }
          await api.updateContent(this.model.uid, this.model)
        } else {
          this.moduleid = await api.createContent(this.model)
        }
        this.$emit('save')
      },
      updateTopicName (newValue, locale, topicID) {
        this.$set(this.model.locales[locale].topicNames, topicID, newValue)
      },
      updateLocaleField (newValue, locale, fieldName) {
        console.log('updateLocaleField', newValue, locale, fieldName)
        this.$set(this.model.locales[locale].extras, fieldName, newValue)
      },
      linkedComputed: function (x) {
        return 'launchLink.' + x
      },
      cancel () {
        this.$emit('cancel')
      },
    },
  }
</script>

<style scoped>
.tag-input span.chip {
  background-color: #1976d2;
  color: #fff;
  font-size: 1em;
}

.tag-input span.v-chip {
  background-color: #1976d2;
  color: #fff;
  font-size:1em;
  padding-left:7px;
}

.tag-input span.v-chip::before {
    content: "label";
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 20px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
}
</style>
